/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import ADGMImage from '../../ADGMImage';
import styles from './styles';

function Layout(props) {
  const { classes, history, type, title, subTitle, data, downloadhandler, isShowPdfButton } = props;
  const [propertyObject, setPropertyObject] = useState('');

  useEffect(() => {
    const lang = localStorage.getItem('lang');
    if (lang === 'en') {
      setPropertyObject(data?.en);
    } else {
      setPropertyObject(data?.ar);
    }
  }, [data]);
  const goToPropertyHandler = () => {
    history.push('/app/applications');
  };
  const renderIcon = typeIcon => {
    if (typeIcon === 'rejection') {
      return 'contractImage.svg';
    }
    if (typeIcon === 'termination') {
      return 'errorIcon.svg';
    }

    return 'successIcon.svg';
  };
  const renderClass = typeClass => {
    if (typeClass === 'rejection') {
      return classes.textHolder;
    }
    if (typeClass === 'termination') {
      return classes.textHolderTermination;
    }

    return classes.textHolderApproval;
  };

  return (
    <Container className={classes.container}>
      <Hidden smUp>
        <div className={classes.mobileTitlehead}>
          <div>
            <FormattedMessage {...messages.success} />
          </div>
        </div>
      </Hidden>
      <Grid container spacing={3} justify='center'>
        <Grid item xs={12} md={6}>
          <div className={classes.contentArea}>
            <div className={classes.bannerArea}>
              <Hidden smUp>
                <div className={classes.textHolder}>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </div>
              </Hidden>
              <div>
                <ADGMImage name={renderIcon(type)} alt='success img' />
              </div>
              <div className={renderClass(type)}>
                <Hidden smDown>
                  <Typography variant='h6' component='h1' className={classes.Title}>
                    {title}
                  </Typography>
                </Hidden>
                <Typography variant='body1'>{subTitle}</Typography>
                {isShowPdfButton && isShowPdfButton === true ? (
                  <>
                    <Button
                      variant='outlined'
                      className={classes.btnADGMOutlineBlack}
                      size='large'
                      onClick={downloadhandler}
                    >
                      <ADGMImage name='Download-contract-black.svg' alt='downloadIcon' className={classes.btnImage} />{' '}
                      <FormattedMessage {...messages.Download_contract} />
                    </Button>
                    {/* <Typography align='right'>
                <Link href='#' variant='body1' className={classes.textDownload} onClick={downloadhandler}>
                  <img src={DownloadIcon} alt='Icon' /> <FormattedMessage {...messages.download_PDF} />
                </Link>
              </Typography> */}
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>

            <Typography align='right' className={classes.applicationIdStyle}>
              <FormattedMessage {...messages.Application_ID} /> : <strong>{propertyObject?.applicationId}</strong>
            </Typography>
            <div className={classes.detailItemHolder}>
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.owner_name_you} />
                  </Typography>
                  <Typography variant='h6' component='h2'>
                    {propertyObject?.ownerName}
                  </Typography>
                </div>
              </div>
              <div className={classes.detailItem}>
                <div className={classes.text}>
                  <Typography variant='body1'>
                    <FormattedMessage {...messages.representative_name} />
                  </Typography>
                  <Typography variant='h6' component='h2'>
                    {propertyObject?.representativeName}
                  </Typography>
                </div>
              </div>
            </div>
            <div className={classes.fixedonMobileHolder}>
              <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                <FormattedMessage {...messages.go_to_applications} />
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(Layout);
